import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import router from '@/router';
import { EventBus } from '@/helpers/EventBusHelper';
import HelpPage from '@/shared/components/HelpPage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsTopBar',
  props: {
    pathBefore: { required: false, type: String, default: '' },
    pathCurrent: { required: true, type: String },
    backRoute: { required: false, type: String },
    showBackButton: { required: false, type: Boolean },
    showSubmitButton: { required: false, type: Boolean },
    submitButtonText: { required: false, type: String, default: 'Submit' },
    submitButtonEvent: { required: false, type: String, default: '' },
    customComponent: { required: false },
    customComponentData: { required: false },
    customComponentCurrentItem: { required: false },
    showCustomComponent: { required: false },
},
  setup(__props) {

const props = __props;



const entityName = computed(() => router.currentRoute.params.entityName);

function goBack(): void {
    if (props.backRoute) {
        router.push({ name: props.backRoute });
        return;
    }

    router.go(-1);
}

function submitOnClick(): void {
    if (!props.submitButtonEvent) {
        return;
    }

    EventBus.$emit(props.submitButtonEvent);
}

return { __sfc: true,props, entityName, goBack, submitOnClick, HelpPage }
}

})